module.exports = __webpack_public_path__ + "img/flower3.9c542ee0.svg";